import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useRef,
} from "react";

import { useAuthContext } from "@contexts/auth";
import { useProjectContext } from "@contexts/projects";
import { useLocation } from "react-router-dom";
import createActions from "./actions";
import reducer from "./reducer";
import initialState from "./state";

const DirectorContext = createContext({ state: initialState, actions: null });

export const DirectorProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const stateRef = useRef(state);
  const { user } = useAuthContext();
  const { activeProject } = useProjectContext();
  const { search } = useLocation();
  const requestedCompanyId = new URLSearchParams(search).get("company_id");
  const preferredCompanyId = requestedCompanyId
    || (activeProject?.company_id ? String(activeProject.company_id) : null);
  stateRef.current = state;
  const actions = useMemo(() => createActions({
    getState: () => stateRef.current,
    dispatch,
    user,
    preferredCompanyId,
  }), [user, preferredCompanyId]);

  useEffect(() => {
    if (user !== undefined) actions.bootstrap();
  }, [user, preferredCompanyId]);

  const value = useMemo(() => ({ state, actions }), [state, actions]);
  return <DirectorContext.Provider value={value}>{children}</DirectorContext.Provider>;
};

export const useDirectorContext = () => useContext(DirectorContext).state;
export const useDirectorActions = () => useContext(DirectorContext).actions;

export default DirectorProvider;
